import clsx from "clsx";
import { FC } from "react";

import styles from "./ChangeSummary.module.css";

interface ChangeSummaryProps {
  adding?: string[];
  editing?: string[];
  removing?: string[];
}

// Multi-line "Adding / Editing / Removing" change summary shared between
// the tags and metadata editors. Categories with zero items are hidden so
// the block disappears entirely when there are no pending changes.
export const ChangeSummary: FC<ChangeSummaryProps> = ({
  adding = [],
  editing = [],
  removing = [],
}) => {
  if (adding.length === 0 && editing.length === 0 && removing.length === 0) {
    return null;
  }
  return (
    <div className={clsx(styles.container, "text-size-smaller")}>
      {adding.length > 0 && (
        <Line label="Adding" accent={styles.accentAdding} items={adding} />
      )}
      {editing.length > 0 && (
        <Line label="Editing" accent={styles.accentEditing} items={editing} />
      )}
      {removing.length > 0 && (
        <Line
          label="Removing"
          accent={styles.accentRemoving}
          items={removing}
        />
      )}
    </div>
  );
};

const Line: FC<{
  label: string;
  accent: string | undefined;
  items: string[];
}> = ({ label, accent, items }) => {
  const joined = items.join(", ");
  return (
    // The full list lives in the `title` attribute so a truncated line
    // is still discoverable on hover.
    <div className={styles.line} title={`${label}: ${joined}`}>
      <span className={clsx(styles.label, accent)}>{label}:</span>{" "}
      <span className={styles.items}>{joined}</span>
    </div>
  );
};
